import { render, staticRenderFns } from "./ActualGame.vue?vue&type=template&id=80abe59e&"
import script from "./ActualGame.vue?vue&type=script&lang=js&"
export * from "./ActualGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../.nvm/versions/node/v10.9.0/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports